import { render, staticRenderFns } from "./first-name-step.vue?vue&type=template&id=4b598d24"
import script from "./first-name-step.vue?vue&type=script&lang=js"
export * from "./first-name-step.vue?vue&type=script&lang=js"
import style0 from "./first-name-step.vue?vue&type=style&index=0&id=4b598d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports